import { Card, CardBody, Col, Row } from "reactstrap";
import { CommonOrganizationStatCardType } from "../../../types/dashboard/Dashboard";
import { H4, H5, H6, SVG } from "../../../AbstractElements";

const CommonOrganizationStatCard = ({
  icon,
  amount,
  title,
  arrowIcon,
  percentage,
  classExtra,
}: CommonOrganizationStatCardType) => {
  return (
    <Col xs="12" sm="6" md="4" xl="4">
      <Card className="total-sales">
        <CardBody>
          <Row>
            <Col xl="12" md="12" sm="12" className="box-col-12">
              <div className={`d-flex align-items-center ${classExtra}`}>
                <span
                  className="d-flex align-items-center justify-content-center rounded-circle bg-light flex-shrink-0"
                  style={{ width: 40, height: 40 }}
                >
                  <SVG iconId={icon} style={{ width: 22, height: 22 }} />
                </span>
                <div className="flex-grow-1 ms-3">
                  <H4 className="mb-1">{amount}</H4>
                  <H6 className="mb-2 text-truncate">{title}</H6>
                  <div className="arrow-chart d-flex align-items-center">
                    <SVG iconId={arrowIcon} style={{ width: 16, height: 16 }} />
                    <H5
                      className={
                        (arrowIcon === "arrow-chart-up" ? "font-success" : "font-danger") + " mb-0 ms-1"
                      }
                    >
                      {percentage}
                    </H5>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CommonOrganizationStatCard;